module.exports = __webpack_public_path__ + "static/media/registrationSuccessMobile.4f5d609f.svg";